import ENUM from "es6-enum";
import { createAction } from "helpers/utils";

const GET_SERVICES_LIST = ENUM('STATIC', 'SUCCESS', 'FAIL');
const CHANGE_CONFIRMATION_REQUIRED = ENUM('STATIC', 'SUCCESS', 'FAIL');

const initialState = {
  list: []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case GET_SERVICES_LIST.STATIC:
    case CHANGE_CONFIRMATION_REQUIRED.STATIC:
      return {
        ...state
      };
    case GET_SERVICES_LIST.SUCCESS:
    case CHANGE_CONFIRMATION_REQUIRED.SUCCESS:
      return {
        ...state,
        list: action.result
      };
    case GET_SERVICES_LIST.FAIL:
    case CHANGE_CONFIRMATION_REQUIRED.FAIL:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
}

/**
 * Get dictionary list.
 * 
 * @export 
 * @returns 
 */
export function getServicesList(page = 0, search = {}) {
  return createAction(GET_SERVICES_LIST, `/services?page=${page}${search.serviceName? `&label=${search.serviceName}` : ''}`, 'get');
}

/**
 * Update service confirmation required
 * 
 * @export 
 * @returns 
 */
 export function changeServiceConfirmationRequired(serviceId, sms_confirmation_required, page = 1, search = {}) {
    return createAction(
        CHANGE_CONFIRMATION_REQUIRED, 
        `/services?page=${page}&id=${serviceId}${search.serviceName? `&label=${search.serviceName}` : ''}`, 
        'patch', 
        { sms_confirmation_required }
    );
  }



// WEBPACK FOOTER //
// ./src/rcapp/redux/actions/confirmation.js